export default function AnimatedBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Gradient pulse overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-purple-600/10 via-indigo-600/10 to-cyan-500/10 animate-pulse"
        style={{ animationDuration: '8s' }}
      />

      {/* Purple floating orb */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-float" />

      {/* Cyan floating orb */}
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-float-delayed" />
    </div>
  );
}
